import { render } from "./GpsRating.vue?vue&type=template&id=5abe48f2&scoped=true"
import script from "./GpsRating.vue?vue&type=script&lang=js"
export * from "./GpsRating.vue?vue&type=script&lang=js"

import "./GpsRating.vue?vue&type=style&index=0&id=5abe48f2&scoped=true&lang=css"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5abe48f2"]])

export default __exports__